import { AppContext } from "../../typings";

const getAppContext = (): AppContext =>
  JSON.parse(localStorage.getItem("app-context") ?? "null") ?? {};

export default getAppContext;
